$(document).ready(function () {

    $('#search').keypress(function (e) {
        if (e.which == 13) EnterButton();
    });

    $(document).on('click', '.js_search', function () {
        EnterButton();
    });

    function EnterButton() {
        const searchInput = $('#search').val();
        window.location.href = `./search?query=${searchInput}`;
    }
});